import React from 'react'
import InterviewImg from 'src/assets/ForSchools/interview.svg'

const InterviewSchedule = () => {
  return (
    <div
      className='container'
      style={{
        fontFamily: 'Space Grotesk',
      }}
    >
      <div className='row'>
        <div className='col-md-12 text-white col-lg-6 col-sm-12 mx-lg-auto mx-md-0 mx-sm-0 align-content-center centering'>
          <img
            src={InterviewImg}
            alt='InterviewSchedule'
            width={500}
            height={500}
            className='img-fluid'
          />
        </div>
        <div className='col-md-12 col-lg-6 col-sm-12 mx-lg-auto mx-md-0 mx-sm-0 align-content-center my-5'>
          <h1 className='fs-1 pb-4 text-white'>
            Interview{' '}
            <span
              className='fw-bold fs-1'
              style={{
                color: '#864D61',
                borderBottom: '4px solid #864D61',
              }}
            >
              {' '}
              Scheduling{' '}
            </span>
          </h1>
          <div className=' text-white fs-3'>
            Schools can send Email or SMS notifications with interview dates &
            times for selected applicants with a single click.
          </div>
        </div>
      </div>
    </div>
  )
}

export default InterviewSchedule
